/**
 * Position des Geräts (Wertobjekt `Geoposition`, LIM-0009): eine Messung auf Anforderung, nie im Hintergrund. Liefert das
 * Gerät keine Position (keine Freigabe, kein Empfang, Zeitüberschreitung), ist das Ergebnis `null` — eine Meldung wird
 * deshalb nie aufgehalten (`schuss/01` „Ohne GPS-Position wird der Schuss trotzdem angenommen“).
 */
export interface Messung {
  position: { Breite: number; Länge: number };
  /** Genauigkeit in ganzen Metern */
  genauigkeit: number;
}

const ZEITGRENZE_MS = 10_000;

export function positionMessen(zeitgrenzeMs = ZEITGRENZE_MS): Promise<Messung | null> {
  return new Promise((fertig) => {
    if (!("geolocation" in navigator)) {
      fertig(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => fertig({ position: { Breite: p.coords.latitude, Länge: p.coords.longitude }, genauigkeit: Math.round(p.coords.accuracy) }),
      () => fertig(null),
      { enableHighAccuracy: true, timeout: zeitgrenzeMs, maximumAge: 0 },
    );
  });
}

/** Übergabe an die Karten-App des Geräts (oberflaeche.md §6 „Navigation“). */
export function navigieren(p: { Breite: number; Länge: number } | null | undefined): void {
  if (p) window.open(`geo:${p.Breite.toFixed(6)},${p.Länge.toFixed(6)}`, "_blank");
}

/** Position aus einer Eingabe `<Breite>, <Länge>` (Dezimalgrad), sonst `null`. */
export function positionLesen(text: string): { Breite: number; Länge: number } | null {
  const teile = text.split(",").map((t) => Number(t.trim()));
  if (teile.length !== 2 || teile.some((t) => !Number.isFinite(t))) return null;
  return { Breite: teile[0]!, Länge: teile[1]! };
}

export function positionText(p: { Breite: number; Länge: number } | null | undefined): string {
  return p ? `${p.Breite.toFixed(6)}, ${p.Länge.toFixed(6)}` : "—";
}
